'use client';

import { useState } from 'react';
import Image from 'next/image';
import "@/styles/aquisition-channel-tabs.css"

type AdquisitionChannel = 'inbound' | 'outbound';

interface AdquisitionChannelTabsProps {
    onTabChange?: (platform: AdquisitionChannel) => void;
    defaultTab?: AdquisitionChannel; // used when uncontrolled
    value?: AdquisitionChannel; // controlled value
}

export const AdquisitionChannelTabs = ({ onTabChange, defaultTab = 'outbound', value }: AdquisitionChannelTabsProps) => {
    const [internalTab, setInternalTab] = useState<AdquisitionChannel>(defaultTab);
    const activeTab = value ?? internalTab;

    const handleTabClick = (platform: AdquisitionChannel) => {
        if (value === undefined) {
            setInternalTab(platform);
        }
        onTabChange?.(platform);
    };

    return (
        <div className="relative rounded-full p-1 md-max:hidden acq-tab-container max-w-[300px]">
            <div className="acq-tab-overlay-mask p-px"></div>

            <div className="relative z-10 h-10 rounded-full flex items-center">
                <div
                    className={`acq-active-tab absolute h-10 rounded-full ${
                        activeTab === 'outbound'
                        ? 'acq-active-inbound left-0 w-[50%]'
                        : 'acq-active-outbound left-[50%] w-[50%]'
                    }`}
                />
                <button
                    type="button"
                    onClick={() => handleTabClick('outbound')}
                    aria-pressed={activeTab === 'outbound'}
                    className={`relative z-10 gap-2 flex-1 h-10 rounded-full flex items-center justify-center transition-colors duration-300 px-3 ${
                        activeTab === 'outbound' ? 'text-emerald-900 font-medium' : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    <Image src="/funnel/outbound.png" alt="Outbound" width={24} height={24} className={`${activeTab === 'outbound' ? 'opacity-100' : 'opacity-50'}`} />
                    Outbound
                </button>
                <button
                    type="button"
                    onClick={() => handleTabClick('inbound')}
                    aria-pressed={activeTab === 'inbound'}
                    className={`relative z-10 gap-2 flex-1 h-10 rounded-full flex items-center justify-center transition-colors duration-300 px-3 ${
                        activeTab === 'inbound' ? 'text-emerald-900 font-medium' : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                    <Image src="/funnel/inbound.png" alt="Inbound" width={24} height={24} className={`${activeTab === 'inbound' ? 'opacity-100' : 'opacity-50'}`} />
                    Inbound
                </button>
            </div>
        </div>
    );
};